import moment from "moment";

export const getNextRoundedTime = (currentDate?: moment.Moment) => {
  const date = currentDate ? currentDate.clone() : moment();

  const now = date.add(1, "hour");
  const minutes = now.minutes();
  const roundedMinutes = Math.ceil(minutes / 5) * 5;

  return now.minutes(roundedMinutes);
};
